import { dayjs } from '@abyss/web/tools/dayjs';

class DateService {
  public static IsValidDateTime = (date: string): string => {
    return (
      typeof date === 'string' &&
      (date.includes('-') || date.includes('/')) &&
      dayjs(
        date,
        'YYYY-MM-DD',
        'MM/DD/YYYY',
        'DD/MM/YYYY',
        'DD-MM-YYYY',
        'YYYY/MM/DD',
        'MMM D, YYYY',
        'MMMM D, YYYY',
        'D MMM YYYY',
        'D MMMM YYYY',
        'YYYY.MM.DD',
        'DD.MM.YYYY',
        true
      ).isValid()
    );
  };

  public static ToDateTime = (date: string): string | null => {
    if (dayjs(date).isValid() === true) {
      return dayjs(date).format('MM/DD/YYYY hh:mm A');
    }
    return null;
  };
  public static ToDate = (date: string): string | null => {
    if (dayjs(date).isValid() === true) {
      return dayjs(date).format('MM/DD/YYYY');
    }
    return null;
  };

  public static ToCustomFormat = (
    date: string,
    format: string
  ): string | null => {
    if (dayjs(date).isValid() === true) {
      return dayjs(date).format(format);
    }
    return null;
  };

  /**
   * Converts an API date string (any format) to MM/DD/YYYY for use with V2DateInput.
   * Uses UTC parsing to prevent timezone-induced day shifts.
   */
  public static FromApiDate = (date: string | null | undefined): string => {
    if (!date) return '';
    const datePart = date.split('T')[0];
    const d = dayjs(datePart, 'YYYY-MM-DD', true);
    return d.isValid() ? d.format('MM/DD/YYYY') : '';
  };

  /**
   * Converts a MM/DD/YYYY string (from V2DateInput) back to YYYY-MM-DD for API submission.
   */
  public static ToApiDate = (
    date: string | null | undefined
  ): string | null => {
    if (!date) return null;
    const d = dayjs(date, 'MM/DD/YYYY', true);
    return d.isValid() ? d.format('YYYY-MM-DD') : null;
  };

  /**
   * Returns true only if the string is a fully complete, calendar-valid MM/DD/YYYY date.
   */
  public static IsValidV2Date = (date: string): boolean => {
    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(date)) return false;
    return dayjs(date, 'MM/DD/YYYY', true).isValid();
  };
}

export { DateService };
